export default __webpack_public_path__ + "static/media/discord-img.da2ff027.png";